import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: props => props.size,
    minWidth: props => props.size,
    height: props => props.size,
    justifyContent: 'space-between',
    position: 'relative',

    '& .chart': {
      '&-circle-bg': {
        fill: 'none',
        stroke: theme.palette.custom.surface[2],
        strokeWidth: '2.5',
      },
      '&-circle-fill': {
        fill: 'none',
        stroke: theme.palette.primary.main,
        strokeWidth: '2.5',
        strokeLinecap: 'round',
        transition: 'all 1s ease-out',

        '&.concluded': {
          stroke: theme.palette.custom.feedback.positive,
        },

        '&:not(.is-active)': {
          strokeDasharray: '0 100',
        },
      },
      '&-text': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        top: 0,
        left: 0,

        '&:not(.material-icons)': {
          ...theme.typography.caption,
          fontSize: props => (props.size > 40 ? '.85em' : '14px'),
          color: theme.palette.text.hint,
        },
        '&.material-icons': {
          fontSize: props => (props.size > 40 ? 24 : 20),
          color: theme.palette.custom.feedback.positive,
        },
      },
    },
  },
}));

export default styles;
